import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Box, Flex } from '@chatterbug/aaron'

import { t } from 'src/lib/i18n-react'
import ellipsis from 'src/ui/UpcomingLessonCard/assets/ellipsis.svg'

const OPTIONS_ICON_SIZE = {
  height: 32,
  width: 32,
}

// https://gomakethings.com/hidden-content-for-better-a11y/#hiding-the-link
const HIDE_VISUALLY = {
  border: '0',
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: '0',
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px',
}

const OPTIONS_POSITION = {
  top: OPTIONS_ICON_SIZE.height + 1,
  right: 5,
}

const OptionsMenu = ({ children }) => {
  const [showPopout, setShowPopout] = useState(false)

  useEffect(() => {
    function closePopout() {
      if (showPopout) {
        setShowPopout(false)
      }
    }
    document.addEventListener('click', closePopout)

    return () => document.removeEventListener('click', closePopout)
  })

  const toggleMenu = () => {
    setShowPopout(!showPopout)
  }

  return (
    <Box
      sx={{
        position: 'relative',
      }}
    >
      <Flex
        as="button"
        borderWidth="0"
        justifyContent="center"
        alignItems="center"
        onClick={toggleMenu}
        height={OPTIONS_ICON_SIZE.height}
        width={OPTIONS_ICON_SIZE.width}
        borderRadius="full"
        aria-haspopup="true"
        aria-expanded={showPopout}
        bg={showPopout ? 'gray95' : 'transparent'}
        sx={{
          position: 'relative',
          ':hover': {
            cursor: 'pointer',
            backgroundColor: 'gray95',
          },
        }}
      >
        <Box as="span" sx={HIDE_VISUALLY}>
          {t('show lesson options')}
        </Box>
        <img src={ellipsis} alt="" />
      </Flex>
      <Box
        as="ul"
        bg="white100"
        boxShadow="raised"
        borderRadius="0,5x"
        sx={{
          display: showPopout ? 'block' : 'none',
          position: 'absolute',
          top: OPTIONS_POSITION.top,
          right: OPTIONS_POSITION.right,
          // this index ensures the the options menu covers absolutely positioned elements
          zIndex: '1000',
        }}
        p="1x"
        width="200px"
      >
        {children}
      </Box>
    </Box>
  )
}

OptionsMenu.propTypes = {
  children: PropTypes.array,
}

export default OptionsMenu
